import { useContext } from "react";
import { Navigate } from "react-router-dom";

import { hasAnyRole, useAuth, UserRole } from "../../context/AuthContext";
import { ChannelState, ChannelSubstate } from "../../models/SKChannel";

const ConditionalNavigation = () => {
  //const { userRoles, myChannel, myInvites } = useContext(UserContext);

  let context = useAuth();

  if (context?.userRoles && hasAnyRole(context?.userRoles, [UserRole.CreatorAdmin, UserRole.BrandAdmin])) {
    if (context?.myChannel) {
      switch (context?.myChannel.status) {
        case ChannelState.DRAFT:
          if (context?.myChannel.subStatus === ChannelSubstate.NONE) {
            return <Navigate replace to="./channels/onboarding" />;
          }
          break;
        case ChannelState.IN_REVIEW:
        case ChannelState.ACTIVE:
          return <Navigate replace to="./channels/view" />;
        default:
      }
    }
    return <Navigate replace to="./channels" />;
  }

  if (context?.myInvites && context?.myInvites.length > 0) {
    return <Navigate replace to="./invitelist" />;
  }

  return <Navigate replace to="./home" />;
};

/*

 hasAnyRole(context?.userRoles ?? [], [UserRole.CreatorAdmin, UserRole.BrandAdmin])
                        ? context?.myChannel
                          ? context.myChannel.status === ChannelState.IN_REVIEW
                            ? "./channels/preview"
                            : "./channels/onboarding"
                          : "./channels/"
                        : context?.myInvites && context.myInvites.length > 0
                        ? "./invitelist"
                        : "./home"
*/

export default ConditionalNavigation;
